import { values, pipe, filter, prop, not } from 'ramda'
import useContractAddendumTemplates from './use-contract-addendum-templates'

const filterActive = pipe(values, filter(pipe(prop('archived'), Number, not)))

const useContractActiveAddendumTemplates = id => {
  const data = useContractAddendumTemplates()
  return filterActive(data)
}

export default useContractActiveAddendumTemplates
